import { PublicClientApplication } from '@azure/msal-browser'
import { microsoftAuthConfiguration } from './mintAuthConfiguration'

let mintAuthInstance: PublicClientApplication | undefined = undefined

export const msalInstance = async () => {
  if (mintAuthInstance) {
    return mintAuthInstance
  } else {
    const configuration = await microsoftAuthConfiguration()
    mintAuthInstance = new PublicClientApplication(configuration)
    await mintAuthInstance.initialize()
    return mintAuthInstance
  }
}
